import { WorkOrder } from 'common/types';
import {
    DOCUMENT_TYPE,
    WORK_ORDER_STATUS,
} from 'common/stores/redux/MetaStore/MetaStoreApi.types';
import { initialProperty } from 'admin/stores/redux/AdminProperty/constants';

export const initialWorkOrder: WorkOrder = {
    created: Date.now().toString(),
    id: null,
    documentTypeId: DOCUMENT_TYPE.WORK_ORDER,
    statusId: WORK_ORDER_STATUS.INITIALIZED,
    propertyId: '',
    opsJobManager: 0,
    occupied: false,
    cleanAndCheck: false,
    lhsRisk: false,
    jobId: null,
    clientId: null,
    contractorId: null,
    contractorTeamMemberId: null,
    property: initialProperty,
    workOrderTypeId: null,
    tradeTypeId: null,
    tradeSubTypeId: null,
    events: [],
};
